import { render, staticRenderFns } from "./purchase-invoice.vue?vue&type=template&id=16194a70&scoped=true&"
import script from "./purchase-invoice.vue?vue&type=script&lang=js&"
export * from "./purchase-invoice.vue?vue&type=script&lang=js&"
import style0 from "./purchase-invoice.vue?vue&type=style&index=0&id=16194a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16194a70",
  null
  
)

export default component.exports